import React, { ReactNode } from 'react';
import { Layout } from 'antd';
import { Colors } from '@common/tokens';
import { useRemoveStaticSkeleton } from '@common/hooks';

import { AppHeader } from '@common/components/app-header';

export const AppLayout = ({
  children,
  sidebar,
}: React.PropsWithChildren<{
  sidebar: ReactNode | undefined;
}>) => {
  useRemoveStaticSkeleton();

  return (
    <>
      <div className="AppLayout">
        <Layout className="app-layout">
          {sidebar}

          <Layout>
            <AppHeader />
            <Layout.Content className="app-layout-content">
              {children}
            </Layout.Content>
          </Layout>
        </Layout>
      </div>
      <style jsx>{`
        .AppLayout :global(.app-layout-content) {
          padding: 72px 0 0 80px;
          background-color: ${Colors.white};
        }
        .AppLayout
          :global(.AppHeader--notification-offset + .app-layout-content) {
          padding-top: 114px;
        }
        .AppLayout
          :global(.AppHeader--double-notification + .app-layout-content) {
          padding-top: 156px;
        }
      `}</style>
    </>
  );
};
